import React, { useEffect, useState } from "react";
import "../../CSS/TeamsPage.css";
import {
  Navbar,
  CreateTeamForm,
  Button,
  JoinTeamForm,
  PopupConfirm,
  CopyText,
} from "../../components/indexComponents";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function TeamsPage() {
  const { teamCode } = useParams();
  const navigate = useNavigate();

  const [teams, setTeams] = useState([]);
  const [formTeam, setFormTeam] = useState(false);
  const [joinTeam, setJoinTeam] = useState(false);
  const [isPopupDisplayed, setIsPopupDisplayed] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasJoined, setHasJoined] = useState(false);

  const joinTeamLink = async (teamCode) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/join-team`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            team_code: teamCode,
          }),
        }
      );

      if (!response.ok) {
        if (response.status === 403) {
          navigate("/teams");
        } else {
          throw new Error("Failed to join team");
        }
      }

      setHasJoined(true);
      navigate("/teams");
    } catch (error) {
      console.error("Error joinning team:", error);
    }
  };

  if (teamCode && !hasJoined) {
    joinTeamLink(teamCode);
  }

  // Récupérer tous les équipes dont l'utilisateur est membre
  const fetchTeams = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/teams`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (!response.ok) {
        setIsLoading(false);
        throw new Error("Failed to fetch teams");
      }

      const data = await response.json();
      setTeams(data);
      const tempArray = teams.map(() => false);
      setIsPopupDisplayed(tempArray);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching teams:", error);
    }
  };

  const leaveTeam = async (teamId) => {
    console.log(teamId);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/leave-team`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            teamId: teamId,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to leave team");
      }

      await fetchTeams();
    } catch (error) {
      console.error("Error leaving teams:", error);
    }
  };

  useEffect(() => {
    fetchTeams();
  }, []);

  return (
    <main id="TeamsPage" className="page-frame">
      <Navbar />

      <div className="TeamsPage-frame page-content">
        <h1>Vos Équipes</h1>
        <div className="add-team-container">
          <div className="btn-container">
            {formTeam ? (
              ""
            ) : (
              <Button
                onClick={() => {
                  setFormTeam(true);
                }}
                text="Créer une équipe"
              />
            )}
            {joinTeam ? (
              ""
            ) : (
              <Button
                onClick={() => {
                  setJoinTeam(true);
                }}
                text="Rejoindre une équipe"
              />
            )}
          </div>

          {formTeam ? (
            <CreateTeamForm
              onTeamAdded={fetchTeams}
              close={() => {
                setFormTeam(false);
              }}
            />
          ) : (
            <div></div>
          )}

          {joinTeam ? (
            <JoinTeamForm
              onTeamJoined={fetchTeams}
              close={() => {
                setJoinTeam(false);
              }}
            />
          ) : (
            <div></div>
          )}
        </div>

        <div className="team-list">
          {!isLoading ? (
            <>
              <h3>Équipes : </h3>
              <ul>
                {teams.map((team, index) => (
                  <li key={index} className="teamCard">
                    {team.name}{" "}
                    <span className="teamCode">
                      code :{" "}
                      <CopyText
                        text={team.team_code}
                        copy={`https://crm.mxbtech.ca/join-team/${team.team_code}`}
                      />
                    </span>
                    <div className="btn-container">
                      <Button
                        route={`/team/${team.id}`}
                        className="see-team-btn"
                        text="Voir"
                      />
                      <Button
                        className="leave-team-btn"
                        text="Quitter"
                        onClick={() => {
                          const tableauModifie = isPopupDisplayed.slice();
                          tableauModifie[index] = true;
                          setIsPopupDisplayed(tableauModifie);
                        }}
                      />
                      {isPopupDisplayed[index] ? (
                        <PopupConfirm
                          text={`Voulez-vous vraiment quitter l'équipe ${team.name} ?`}
                          textBtnConfirm="Quitter"
                          onClickConfirm={() => leaveTeam(team.id)}
                          textBtnCancel="Annuler"
                          onClickCancel={() => {
                            const tableauModifie = isPopupDisplayed.slice();
                            tableauModifie[index] = false;
                            setIsPopupDisplayed(tableauModifie);
                          }}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <>
              <div>
                <h1>Chargement des équipes...</h1>
              </div>
            </>
          )}
        </div>
      </div>
    </main>
  );
}

export default TeamsPage;
